
	export const lang = [{
	zhen_1:'大图',
	zhen_2:'列表',
	zhen_3:'当前功能需登录后才可使用',
	zhen_4:'立即登录',
	zhen_5:'没有更多数据了',
	zhen_6:'努力建设中，敬请期待!',
	zhen_7:'当前功能需登录后才可使用',
	zhen_8:'删除',
	zhen_9:'重命名',
	zhen_10:'云文档',
	zhen_11:'云模板',
	zhen_12:'云共享',
	zhen_13:'取消',
	zhen_14:'确认删除',
	zhen_15:'立即登录',
	zhen_16:'确认',
	zhen_17:'我要反馈',
	zhen_18:'名称',
	zhen_19:'大小',
	zhen_20:'时间',
	zhen_21:'暂无',
	zhen_22:'的模板，点击下面按钮反馈。',
	zhen_23:'删除成功',
	zhen_24:'修改成功',
	zhen_25:'只能修改单个标签名',
	zhen_26:'全部',
	zhen_27:'全选',
	zhen_28:'全不选',
	zhen_29:'删除标签',//delete a tap
	zhen_30:'删除后无法恢复',
	zhen_31:'请输入标签名称',
	zhen_32:'标签名不能为空!',
	zhen_33:'请选择删除元素',
	zhen_34:'请输入搜索内容',
	zhen_35:'的模板，请新增模板',
}
, {
	zhen_1:'Big picture',
	zhen_2:'List',
	zhen_3:'Current functions need to be logged in before they can be used',
	zhen_4:'Login',
	zhen_5:'No more data',
	zhen_6:'In the process of construction, please look forward to it!',
	zhen_7:'Current functions need to be logged in before they can be used',
	zhen_8:'Delete',
	zhen_9:'Rename',
	zhen_10:'Document',
	zhen_11:'Template',
	zhen_12:'Share',
	zhen_13:'Cancle',
	zhen_14:'Confirm',
	zhen_15:'Login',
	zhen_16:'Confirm',
	zhen_17:'Feedback',
	zhen_18:'Sort by name',
	zhen_19:'Sort by size',
	zhen_20:'Sort by time',
	zhen_21:'No time',
	zhen_22:'Template, click the button below for feedback.',
	zhen_23:'Successful deletion',
	zhen_24:'Successful revision',
	zhen_25:'Only a single label name can be modified',
	zhen_26:'All',
	zhen_27:'All',
	zhen_28:'NotAll',
	zhen_29:'Delete tap',//delete a tap
	zhen_30:'Unrecoverable after deletion',
	zhen_31:'Please enter the label name',
	zhen_32:'Label name cannot be empty',
	zhen_33:'Please select Delete element',
	zhen_34:'Please enter the search content',
	zhen_35:'Template, Please add a new template'
}
, {
	zhen_1:'大圖',
	zhen_2:'清單',
	zhen_3:'當前功能需登入後才可使用',
	zhen_4:'立即登录',
	zhen_5:'沒有更多數據了',
	zhen_6:'努力建设中，敬请期待!',
	zhen_7:'當前功能需登入後才可使用',
	zhen_8:'删除',
	zhen_9:'重命名',
	zhen_10:'雲文檔',
	zhen_11:'雲範本',
	zhen_12:'雲共亯',
	zhen_13:'取消',
	zhen_14:'確認删除',
	zhen_15:'立即登录',
	zhen_16:'確認',
	zhen_17:'我要迴響',
	zhen_18:'名稱',
	zhen_19:'大小',
	zhen_20:'時間',
	zhen_21:'暫無',
	zhen_22:'的範本，點擊下麵按鈕迴響。',
	zhen_23:'删除成功',
	zhen_24:'修改成功',
	zhen_25:'只能修改單個標籤名',
	zhen_26:'全部',
	zhen_27:'全選',
	zhen_28:'全不選',
	zhen_29:'删除標籤',//delete a tap
	zhen_30:'删除後無法恢復',
	zhen_31:'請輸入標籤名稱',
	zhen_32:'標籤名不能為空!',
	zhen_33:'請選擇删除元素',
	zhen_34:'請輸入蒐索內容',
	zhen_35:'的範本，請新增範本'
}]
